import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { MatAnchor, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatToolbar } from '@angular/material/toolbar';
import { LogoutService } from 'app/shared/services/logout.service';
import { StudentProfileResponse } from '../../api/client-student.service';
import { StudentService } from '../../services/student.service';
import { HelpContactMenuComponent } from '../help-contact-menu/help-contact-menu.component';

@Component({
  selector: 'app-student-header',
  templateUrl: './student-header.component.html',
  styleUrls: ['./student-header.component.scss'],
  imports: [MatToolbar, MatButton, MatAnchor, MatIcon, MatMenu, MatMenuItem, MatMenuTrigger, RouterLink, HelpContactMenuComponent],
})
export class StudentHeaderComponent implements OnInit {
  private readonly authService = inject(LogoutService);
  private readonly router = inject(Router);
  private readonly studentService = inject(StudentService);
  private readonly cdr = inject(ChangeDetectorRef);

  studentName = 'Student Profile';
  studentEmail = 'Loading...';
  showEmailUpdate = false;

  readonly profileMenuItems = [
    // { action: 'view-declaration', label: 'View Customer Declaration', icon: 'description' },
    { action: 'consents', label: 'View Consents', icon: 'security', routerLink: '/student/consents' },
    // { action: 'payment-history', label: 'View Payment History', icon: 'payment' },
    { action: 'update-email', label: 'Update Email', icon: 'email', routerLink: '/student/update-email' },
    // { action: 'update-password', label: 'Update Password', icon: 'lock' },
  ];

  async ngOnInit(): Promise<void> {
    try {
      const student: StudentProfileResponse = await this.studentService.student({ url: 'student', cacheMins: 1 });
      const personalDetails = student.personalDetails;
      this.studentName = [personalDetails.firstName, personalDetails.lastName].filter(Boolean).join(' ') || 'Student Profile';
      this.studentEmail = personalDetails.email || '';
      this.showEmailUpdate = Boolean(personalDetails.firstName?.trim());
    } catch {
      this.studentEmail = '';
    } finally {
      // The profile may be returned from cache during the current render turn.
      // Refresh this component after the async state update to avoid NG0100.
      this.cdr.detectChanges();
    }
  }

  async logout() {
    try {
      await this.authService.logout();
      this.router.navigate(['/sessions/signin']);
    } catch {
      this.authService.removeTokens();
      location.reload();
    }
  }
}
